import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pruta-agent-female.svg")